/**
 */
const MAX_WEBGL_CONTEXTS = 12; //brought this down to help Unity not get evicted
let activeCount = 0;

const DEBUG = import.meta.env?.DEV ?? false;
const log = (msg, ...args) => DEBUG && console.log("[WebGLPool]", msg, ...args);

export function tryAcquireWebGLSlot() {
  const limit = MAX_WEBGL_CONTEXTS;
  const acquired = activeCount < limit;
  if (acquired) activeCount += 1;
  log(`tryAcquire: ${acquired ? "ok" : "full"} (count ${activeCount}/${limit})`);
  return acquired;
}

export function releaseWebGLSlot() {
  if (activeCount > 0) activeCount -= 1;
  log("release → count", activeCount);
}

export function getActiveWebGLCount() {
  return activeCount;
}
